import SnippetsGrid from '../components/Grid';
import { SnippetProvider } from '../store';

export default function SnippetsGridLayout() {
  return <SnippetProvider>
    <SnippetsGrid />
  </SnippetProvider>;
}
